<template>
  <li @mouseenter="hoverOnElement = true" @mouseleave="hoverOnElement = false">
    <span
      v-if="item.path === '/' && item.items?.length"
      class="cursor-pointer flex justify-between items-center px-10"
      :class="{
        'py-4 lg:py-2.5 hover:text-primary': nestedMenu,
        'py-7': !nestedMenu,
        'font-semibold text-primary': isClicked && nestedMenu,
        'bg-primary/10': isClicked && nestedMenu,
        'bg-white/10': isClicked && !nestedMenu,
      }"
      @click="clickHandler"
    >
      {{ item.title }}
      <svg
        :width="nestedMenu ? '14' : '18'"
        :height="nestedMenu ? '14' : '18'"
        viewBox="0 0 18 18"
        :class="{ 'animate__animated animate__headShake': hoverOnElement }"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.07324 2.85352L13.1465 8.92681L7.07324 15.0001"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          :class="
            nestedMenu && !isClicked
              ? 'text-grey-light'
              : nestedMenu && isClicked
                ? 'text-primary'
                : !nestedMenu && !isClicked
                  ? 'text-white/50'
                  : 'text-white'
          "
        />
      </svg>
    </span>
    <NuxtLink
      v-else
      :to="item.path"
      :target="item.type === 'EXTERNAL' ? '_blank' : ''"
      class="px-10"
      :class="`block ${nestedMenu ? 'py-4 lg:py-2.5 hover:text-primary' : 'py-7'}`"
      @click="openNavigation = false"
      >{{ item.title }}
    </NuxtLink>
  </li>
</template>
<script setup lang="ts">
import 'animate.css'

const openNavigation = useOpenNavigation()
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  nestedMenu: {
    type: Boolean,
    default: false,
  },
  forceUnclick: {
    type: Boolean,
    default: false,
  },
})
const isClicked = ref(false)
const hoverOnElement = ref(false)

watch(
  () => props.forceUnclick,
  (value) => {
    if (value) {
      isClicked.value = false
    }
  },
  { immediate: true },
)

const emit = defineEmits(['click'])
const clickHandler = () => {
  isClicked.value = !isClicked.value
  emit('click', isClicked.value ? props.item : null)
}

onUnmounted(() => {
  isClicked.value = false
})
</script>
